// extracted by mini-css-extract-plugin
module.exports = {"mobile_news_container":"MobileNewsTabs_mobile_news_container__2T96n"};